import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { FileUpload, FilterAlt } from "@mui/icons-material"
import AddIcon from '@mui/icons-material/Add';
import Table from "../../../components/Table"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { deleteData, fetchData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useDispatch, useSelector } from "react-redux"
import { useSnackbar } from "../../../context/popup"
import BulkUpload from "../../../components/blukUplod"
import { useLoading } from "../../../components/Loading"
import CityListFilterDialog from './components/CityListFilterDialog.js';

const CityList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { setCircleLoading } = useLoading();
    const { showSnackbar } = useSnackbar();

    const currentPage = useSelector((state) => state?.generalCityStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.generalCityStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.generalCityStore?.totalPages);

    const [cityData,setCityData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        countryId: "",
        stateId: "",
        districtId: "",
    });
    

    useEffect(() => {
        fetchCityList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchCityList = async () => {
        setCircleLoading(true);
        try {
        let url = `/reference/general/city?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}&countryId=${filterData?.countryId}&stateId=${filterData?.stateId}&districtId=${filterData?.districtId}`
        if(filterData.isActive !== "" && filterData.isActive !== null && filterData.isActive !== undefined) {
            url += `&isActive=${filterData.isActive}`;
        }
        const response = await fetchData(url);
        
        if(response?.success){
            setCityData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));
        }
        else{
            //throw error
            showSnackbar("Failed to fetch data", "error");
        }
        } catch (error) {
        console.error('Error Fetching States:', error);
        showSnackbar(error?.response?.data?.message || 'Network Error', "error");
        }
        finally{
            setCircleLoading(false);
        }
    }

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/reference/general/city-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message, "error");
        }
    };

    //Table Mapping
    const cityListTable = {
        columns: [
            { key: "sno", label: "S.No.", renderCell: (row) => row.sno },
            { key: "name", label: "City Name", renderCell: (row) => row.name },
            { key: "displayName", label: "Display Name", renderCell: (row) => row.displayName },
            { key: "district", label: "District Name", renderCell: (row) => row.district },
            { key: "state", label: "State Name", renderCell: (row) => row.state },
            { key: "country", label: "Country Name", renderCell: (row) => row.country },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],

        rows: cityData?.map((city, index) => ({
            id: city?.id,
            sno: index + 1,
            iplCityId: city?.iplCityId || "",
            name: city?.name || "",
            displayName: city?.displayName || "",
            district: city?.district?.name || "",
            state: city?.district?.state?.name || "",
            country: city?.district?.state?.country?.name || "",
            isActive: city?.isActive,
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/general-master/city-list/city-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/general-master/city-list/city-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    //Handle Click Add City
    const handleAddNewCity = () => {
        navigate(`/general-master/city-list/city-details`);
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader
        title={(
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        City List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Cities around the world.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt/>}
                    onClick={(event) => setAnchorEl(event.currentTarget)}

                    >
                        Filter
                    </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FileUpload/>}
                    onClick={() => setOpenUploadFileDialog(true)}>
                        Bulk Upload
                    </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleAddNewCity()}
                    >
                        City
                    </MaterialButton>
                </Stack>
            </Stack>
        )} 
        />
        <CardContent>
            <Table
            columns={cityListTable?.columns}
            data={cityListTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No General Cities found"
            handleSearch={handleSearch}
            />
        </CardContent>
        <BulkUpload
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        endPoint="/reference/master/bulkUpload/general-city"
        fetchList={fetchCityList}
        />
        <CityListFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchCityList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default CityList